export default {
  title: {
    id: 'asp_action_bar_ship_back_item_step_title',
    defaultMessage: 'Repair, replace, or return an item',
  },
  enterShippingInfoIntro: {
    id: 'bo_sellers.customer_care.request.action_bar.ship_back.intro',
    defaultMessage: 'Please add the return shipping details.',
  },
}
